export default "__VITE_ASSET__Bsg6HYVi__"